import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import Search from '../Search';
import { messages } from './messages';

const TableWrapper = ({ children, actions, label, setSearch, miniTable }) => {
  const intl = useIntl();

  return (
    <div className="table-wrapper">
      <div className="table-wrapper-header">
        <div className="table-wrapper-header-left">
          {miniTable && <div className="table-wrapper-header-title">
            {label}
          </div>}
          <Search
            placeholder={intl.formatMessage(messages.search, { label })}
            onChange={(value) => setSearch(value)}
          />
        </div>
        <div className="table-wrapper-header-actions">
          {actions}
        </div>
      </div>
      <div className={`table-wrapper-content ${miniTable && 'mini-table'}`}>
        {children}
      </div>
    </div>
  );
};

TableWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  label: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  miniTable: PropTypes.bool,
};

TableWrapper.defaultProps = {
  actions: null,
  miniTable: false,
};

export default TableWrapper;
